import React, { Component } from 'react';
import reduxDialog, { closeDialog, openDialog } from '../../../lib/redux-reactstrap-modal';
import { connect } from "react-redux";
import { compose } from 'recompose';
import { bindActionCreators } from "redux";
import PermissionForm from './PermissionForm';

class PermissionModal extends Component {
    
    
    render() {  
        const {data:{applicationId,userId,editUser}}=this.props;
      
        return (            
            <div className="modal-signin">
                <div className="modal-header">
                    <h2>{applicationId===2?'Publisher':'Advertiser'}</h2>
                    <button type="button" className="close" 
                        onClick={() => this.props.closeDialog('MODAL_PERMISSION')}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                   
                </div>
                <div className="modal-body">
                    <div className="modal-body-padding p-4">
                        <PermissionForm applicationId={applicationId} userId={userId} editUser={editUser}/>                        
                    </div>                   
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ closeDialog, openDialog }, dispatch);
}

const WithDialog = compose(reduxDialog(connect, 
    { name: 'MODAL_PERMISSION',backdrop:'static',centered: true, className: 'modal-right modal-lg'}))(PermissionModal);
const ConnectedWithDialog = connect(null, mapDispatchToProps)(WithDialog);

export default ConnectedWithDialog;

